'use client'
import { ChangeEvent, Dispatch, ReactNode } from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'
import styles from './Checkbox.module.scss'

type Props = {
  id: string
  label: string | ReactNode
  type?: 'radio' | 'checkbox'
  option: string
  fieldValue: string[]
  setFieldValue: Dispatch<string[]>
  field: ControllerRenderProps<FieldValues, string>
}

const Checkbox = ({ id, label, type = 'checkbox', option, fieldValue, setFieldValue, field }: Props) => {
  function checkboxClicked(e: ChangeEvent<HTMLInputElement>) {
    const valueCopy = [...fieldValue]
    if (e.target.checked) {
      valueCopy.push(e.target.value)
    } else {
      valueCopy.splice(
        valueCopy.findIndex((x) => x === e.target.value),
        1
      )
    }
    field.onChange(valueCopy)
    setFieldValue(valueCopy)
  }

  return (
    <li className={styles.container}>
      {type === 'radio' ? (
        <input id={id} type={type} {...field} value={option} />
      ) : (
        <input id={id} type={type} checked={fieldValue.includes(option)} value={option} onChange={checkboxClicked} />
      )}
      <label className={styles.checkbox} htmlFor={id} />
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </li>
  )
}

export default Checkbox
